import React from 'react';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import useStyles from './styles';

function Header() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ShoppingCartIcon fontSize="large" />
      <span>Carrinho</span>
    </div>
  );
}

export default Header;
